import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Zap, Shield } from 'lucide-react';
import { trackAddToCart } from '../lib/pixel';
export const FinalCTA = () => {
  return <section className="py-24 sm:py-32 px-4 bg-brand-dark text-brand-light text-center" data-id="element-31">
      <div className="max-w-3xl mx-auto" data-id="element-32">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-33">
          <h2 className="font-serif text-4xl sm:text-6xl font-bold mb-10 leading-tight" data-id="element-34">
            Ready to become{' '}
            <span className="text-brand-accent" data-id="element-35">unreplaceable?</span>
          </h2>

          <a href="https://floctiva.com/cart/53063149912380:1" onClick={() => trackAddToCart()} className="inline-block w-full sm:w-auto bg-brand-accent text-white font-bold text-xl sm:text-2xl px-8 sm:px-12 py-6 rounded-sm hover:bg-brand-accent/90 transition-all transform hover:scale-105 shadow-2xl shadow-brand-accent/20 mb-8" data-id="element-36">
            YES! I WANT TO BECOME UNREPLACEABLE
            <span className="block text-sm sm:text-base font-medium text-white/80 mt-2" data-id="element-37">
              GET ACCESS FOR $47
            </span>
          </a>

          <p className="text-brand-light/60 font-medium mb-12" data-id="element-38">
            One-time payment. Instant delivery. Secure your future now.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-12 text-brand-light/50 text-sm font-medium" data-id="element-39">
            <div className="flex items-center gap-2" data-id="element-40">
              <Lock className="w-5 h-5" data-id="element-41" />
              Secure Checkout
            </div>
            <div className="flex items-center gap-2" data-id="element-42">
              <Zap className="w-5 h-5" data-id="element-43" />
              Instant Access
            </div>
            <div className="flex items-center gap-2" data-id="element-44">
              <Shield className="w-5 h-5" data-id="element-45" />
              30-Day Guarantee
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};